/** The state of the settings (Saved or Published) */
export var State;
(function (State) {
    /** Not relevant */
    State["NR"] = "NR";
    State["SAVED"] = "SAVED";
    State["PUBLISHED"] = "PUBLISHED";
})(State || (State = {}));
/** The host in which the settings are displayed */
export var Host;
(function (Host) {
    Host["NA"] = "NA";
    Host["VIEWER"] = "VIEWER";
    Host["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    Host["ONE_APP"] = "ONE_APP";
})(Host || (Host = {}));
/** scope of settings when creating/updating; */
export var Scope;
(function (Scope) {
    /** multiple instances of a tpa can share same settings; */
    Scope["APP"] = "APP";
    /** scoped to a single component of an app; */
    Scope["COMPONENT"] = "COMPONENT";
})(Scope || (Scope = {}));
//# sourceMappingURL=types.impl.js.map